module.exports = __webpack_public_path__ + "img/toolimg3.e02d5275.png";